import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/category/:slug',
    lazy: () => import('@/pages/category/page'),
  },
  {
    path: '/article/:id',
    lazy: () => import('@/pages/article/page'),
  },
  {
    path: '/about',
    lazy: () => import('@/pages/about/page'),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;